import StoreRepository from './StoreRepository'
import ProductRepository from './ProductRepository'
import AccountRepository from './AccountRepository'
import ProjectRepository from './ProjectRepository'
import ProofRepository from './ProofRepository'
import ProofCommentRepository from './ProofCommentRepository'
import ProofReviewerRepository from './ProofReviewerRepository'
import WidgetRepository from './WidgetRepository'
import OrderRepository from './OrderRepository'
import UserRepository from './UserRepository'
import NotificationRepository from './NotificationRepository'
import ProofProcessingRepository from './ProofProcessingRepository'
import CustomerPricingRepository from './CustomerPricingRepository'
import StripeCardRepository from './StripeCardRepository'
import UploadRepository from './UploadRepository'
import OrderMoveRepository from './OrderMoveRepository'
import EpubRepository from './EpubRepository'
import InvoiceRepository from './InvoiceRepository'
import OnlineOrderRepository from './OnlineOrderRepository'
import OnlineOrderItemRepository from './OnlineOrderItemRepository'
import InternalCommentRepository from './InternalCommentRepository'
import YpaRepository from './YpaRepository'
import FileRepository from './FileRepository'
import CustomerIoActionRepository from './CustomerIoActionRepository'
import ProcessorStatusesRepository from './ProcessorStatusesRepository'
import DiscountRepository from './DiscountRepository'
import FundRequestRepository from './FundRequestRepository'
import TeacherGradeCombinationRepository from './TeacherGradeCombinationRepository'
import ApiRepository from './ApiRepository'
import SummerFundRequestRepository from './SummerFundRequestRepository'
import MarketingRepository from './MarketingRepository'
import PersonalizationUploadRepository from './PersonalizationUploadRepository'
import ManufacturingPlantRepository from './ManufacturingPlantRepository'
import ProofInternalActionRepository from './ProofInternalActionRepository'
import ShipmentRepository from './ShipmentRepository'
import QuickbooksInvoiceRepository from './QuickbooksInvoiceRepository'
import CarrierRepository from './CarrierRepository'
import ManufacturerRepository from './ManufacturerRepository'
import SettingsRepository from './SettingsRepository'
import SalesTaxRequestRepository from './SalesTaxRequestRepository'
import ShipToHomePricesRepository from './ShipToHomePricesRepository'
import ShipToHomeShippingPricesRepository from './ShipToHomeShippingPricesRepository'
import PricingAdjustmentRepository from './PricingAdjustmentRepository'
import EmailRepository from './EmailRepository'
import MarketingCampaignRepository from './MarketingCampaignRepository'
import MarketingContactRepository from './MarketingContactRepository'
import OrderStatusNotificationRepository from './OrderStatusNotificationRepository'

const repositories = {
  'stores': StoreRepository,
  'products': ProductRepository,
  'accounts': AccountRepository,
  'projects': ProjectRepository,
  'proofs': ProofRepository,
  'proof_comments': ProofCommentRepository,
  'proof_reviewers': ProofReviewerRepository,
  'orders': OrderRepository,
  'widgets': WidgetRepository,
  'users': UserRepository,
  'notifications': NotificationRepository,
  'proof_processing': ProofProcessingRepository,
  'customer_pricings': CustomerPricingRepository,
  'stripe_cards': StripeCardRepository,
  'uploads': UploadRepository,
  'order_moves': OrderMoveRepository,
  'epubs': EpubRepository,
  'invoices': InvoiceRepository,
  'online_orders': OnlineOrderRepository,
  'internal_comments': InternalCommentRepository,
  'ypa': YpaRepository,
  'files': FileRepository,
  'online_order_items': OnlineOrderItemRepository,
  'customer_io_actions': CustomerIoActionRepository,
  'processor_statuses': ProcessorStatusesRepository,
  'discounts': DiscountRepository,
  'fund_requests': FundRequestRepository,
  'teacher_grade_combinations': TeacherGradeCombinationRepository,
  'api': ApiRepository,
  'summer_fund_requests': SummerFundRequestRepository,
  'marketing': MarketingRepository,
  'personalization_uploads': PersonalizationUploadRepository,
  'manufacturing_plants': ManufacturingPlantRepository,
  'proof_internal_actions': ProofInternalActionRepository,
  'shipments': ShipmentRepository,
  'quickbooks_invoices': QuickbooksInvoiceRepository,
  'carrier': CarrierRepository,
  'manufacturers': ManufacturerRepository,
  'settings': SettingsRepository,
  'sales_tax_requests': SalesTaxRequestRepository,
  'ship_to_home_prices': ShipToHomePricesRepository,
  'ship_to_home_shipping_prices': ShipToHomeShippingPricesRepository,
  'pricing_adjustments': PricingAdjustmentRepository,
  'emails': EmailRepository,
  'marketing_campaigns': MarketingCampaignRepository,
  'marketing_contacts': MarketingContactRepository,
  'order_status_notifications': OrderStatusNotificationRepository
}

export default {
  get: name => repositories[name]
}
